import { Input } from 'antd';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

interface Props {
  initialValue: string;
  handleNewValue: (newValue: string) => void;
}

export const AnnotationFieldResult = ({ initialValue, handleNewValue }: Props) => {
  const inputRef = useRef<Input>(null);
  const [theValue, setTheValue] = useState<string>(initialValue);
  const [editing, setEditing] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue !== theValue) {
      setTheValue(initialValue);
    }
    // eslint-disable-next-line
  }, [initialValue]);

  useLayoutEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [editing]);

  const handleDoubleClick = () => {
    setEditing(true);
  };

  const handleSubmitValue = () => {
    handleNewValue(theValue);
    setEditing(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === 'Escape') {
      handleSubmitValue();
    }
  };

  return (
    <>
      {editing ? (
        <Input
          size="small"
          ref={inputRef}
          value={theValue}
          onChange={e => setTheValue(e.currentTarget.value)}
          onKeyDown={e => handleKeyDown(e)}
          onKeyUp={e => e.stopPropagation()}
          onBlur={handleSubmitValue}
        />
      ) : initialValue ? (
        <div style={{ margin: '1px 0', width: '100%' }} onDoubleClick={handleDoubleClick}>
          {theValue || initialValue}
        </div>
      ) : (
        <div style={{ margin: '1px 0', width: '100%' }} onDoubleClick={handleDoubleClick}>
          &nbsp;
        </div>
      )}
    </>
  );
};
